import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { initAnalytics, track } from '@/services/analytics';

/** Meta Pixel PageView on every path or query change (as the current site), except staff areas. */
export function usePageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    if (pathname.startsWith('/admin') || pathname.startsWith('/agency')) return;
    track('PageView');
  }, [pathname, search]);
}
